<template>
  <div class="aboutUs pointer">
    <NavBar title="关于我们"></NavBar>
    <div class="content">
      <div class="brand_name">
        <img src="@/assets/logo.png" alt="" />
        <p>迅流云手机</p>
      </div>
      <div class="agreement">
        <div>
          <span class="privacy" @click="toAgreement(0)">【用户协议】</span>
          和
          <span class="privacy" @click="toAgreement(1)">【隐私政策】</span>
        </div>
        <div class="privacy" @click="toAgreement(2)">
          《迅流云手机平台免责声明》
        </div>
      </div>
    </div>
  </div>
</template>
          <script>
import NavBar from "@/components/NavBar.vue";
export default {
  name: "AboutUs",
  components: {
    NavBar,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    toAgreement(type) {
      if (type == 0) {
        location.href = "http://static.aixunliu.com/app/user_agreement.html";
      }
      if (type == 1) {
        location.href = "http://static.aixunliu.com/app/privacy_policy.html";
      }
      if (type == 2) {
        location.href = "http://static.aixunliu.com/app/disclaimer.html";
      }
    },
  },
};
</script>
          
      <style lang="less" scoped>
.aboutUs {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 70px 0 40px 0;
    .brand_name {
      img {
        width: 70px;
        height: 70px;
      }
      p {
        font-size: 22px;
        font-weight: bold;
        margin: 10px 0;
        font-style: italic;
      }
    }
    .agreement {
      color: #999;
      font-size: 16px;
      .privacy {
        color: #886df3;
      }
    }
  }
}
</style>